import React from 'react'

import './index.scss'

interface H2Required {
	children: React.ReactNode
}

interface H2Optional {
	className?: string
}

interface IH2Props extends H2Required, H2Optional {}

const H2: React.FC<IH2Props> = ({ className = '', children }) => (
	<h2 className={`h2 ${className}`}>{children}</h2>
)

export default H2
